import { Component, OnInit } from '@angular/core';
import { VendorDashboardService } from 'src/app/services/vendor-dashboard.service';
import { first } from 'rxjs';
import { MessageService } from 'primeng/api';
import { AppLoaderService } from 'src/app/services/app-loader/app-loader.service';
import { CryptoJsService } from 'src/app/services/crypto-js.service';

@Component({
  selector: 'app-update-mi-component-cml-validity',
  templateUrl: './update-mi-component-cml-validity.component.html',
  styleUrls: ['./update-mi-component-cml-validity.component.scss'],
})
export class UpdateMiComponentCmlValidityComponent implements OnInit {
  constructor(
    private messageService: MessageService,
    private vendorService: VendorDashboardService,
    private loader: AppLoaderService,
    private cryptoJsService: CryptoJsService,
  ) {}

  public vendorRegId: any;
  public userId: any;

  public program: any;
  public selectedProgram: any = [];
  public vendor: any;
  public selectedVendor: any = [];
  public category: any;
  public selectedCategory: any = [];
  // public component: any;
  // public selectedComponent: any = [];
  public cml: any;
  public selectedCML: any = [];

  public programId: any;
  public vendorId: any;
  public categoryId: any;
  // public componentId: any;
  public cmlId: any;

  // public enteredCMLNo: number;

  public selectedDate: Date;
  public filteredVendor: any[];

  ngOnInit(): void {
    this.loadData();
  }

  loadData() {
    const token: any = JSON.parse(this.cryptoJsService.DecryptToken(sessionStorage.getItem('token')));   
    let payload = atob(token?.authToken?.split('.')[1]);
    this.userId = JSON.parse(payload)?.sub;
    this.vendorRegId = JSON.stringify(token?.officeCode);

    this.program = null;
    this.programId = null;
    this.selectedProgram = [];
    this.vendor = null;
    this.vendorId = null;
    this.selectedVendor = [];
    this.category = null;
    this.categoryId = null;
    this.selectedCategory = [];
    // this.component = null;
    // this.componentId = null;
    // this.selectedComponent = [];
    this.cml = null;
    this.cmlId = null;
    this.selectedCML = [];

    this.selectedDate = null;
    this.getComponentMaster();
  }

  getComponentMaster() {
    this.loader.start();
    this.vendorService
      .getComponentMaster()
      .pipe(first())
      .subscribe({
        next: (res) => {
          this.program = res;
          this.loader.close();
        },
        error: (err) => {
          this.loader.close();
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });
  }

  onSelectProgram() {
    this.vendor = null;
    this.vendorId = null;
    this.selectedVendor = [];
    this.category = null;
    this.categoryId = null;
    this.selectedCategory = [];
    // this.component = null;
    // this.componentId = null;
    // this.selectedComponent = [];
    this.cml = null;
    this.cmlId = null;
    this.selectedCML = [];
    this.selectedDate = null;
    this.programId = this.selectedProgram?.Program_Id;
    this.getAllMIVendersDropdown();
  }

  getAllMIVendersDropdown() {
    this.loader.start();
    this.vendorService
      .getAllMIVendors(this.programId)
      .pipe(first())
      .subscribe({
        next: (res) => {
          this.vendor = res;
          this.loader.close();
        },
        error: (err) => {
          this.loader.close();
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });
  }

  onSelectVendor(event) {
    this.category = null;
    this.categoryId = null;
    this.selectedCategory = [];
    // this.component = null;
    // this.componentId = null;
    // this.selectedComponent = [];
    this.cml = null;
    this.cmlId = null;
    this.selectedCML = [];
    this.selectedDate = null;
    this.vendorId = this.selectedVendor?.Vendor_Code;
    this.getCategoryDropdown();
  }

  filterVendor(event: any) {
    const filtered: any[] = [];
    const query = event.query;
    for (let i = 0; i < this.vendor.length; i++) {
      const vendorName = this.vendor[i];
      if (vendorName.Name.toLowerCase().indexOf(query.toLowerCase()) == 0) {
        filtered.push(vendorName);
      }
    }

    this.filteredVendor = filtered;
  }

  

  getCategoryDropdown() {
    const reqBody = {
      VendorRegId: this.vendorId,
      ProgramId: this.programId,
    };
    this.loader.start();
    this.vendorService
      .getCategory(reqBody)
      .pipe(first())
      .subscribe({
        next: (res) => {
          this.category = res.$values;
          this.loader.close();
        },
        error: (err) => {
          this.loader.close();
          this.category = [];
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });
  }

  onSelectCategory() {
    // this.component = null;
    // this.componentId = null;
    // this.selectedComponent = [];
    this.cml = null;
    this.cmlId = null;
    this.selectedCML = [];
    this.selectedDate = null;
    this.categoryId = this.selectedCategory?.categoryId;
    // this.getComponentDropdown();
    this.getCMLNumber();
  }

  // getComponentDropdown() {
  //   const reqBody = {
  //     VendorRegId: this.vendorId,
  //     ProgramId: this.programId,
  //     CategoryId: this.categoryId,
  //   };

  //   this.vendorService
  //     .getComponent(reqBody)
  //     .pipe(first())
  //     .subscribe({
  //       next: (res) => {
  //         this.component = res.$values;
  //       },
  //       error: (err) => {
  //         this.messageService.add({
  //           severity: 'error',
  //           summary: 'Error Message',
  //           detail: err,
  //         });
  //       },
  //     });
  // }

  // onSelectComponent() {
  //   this.cml = null;
  //   this.cmlId = null;
  //   this.selectedCML = [];
  //   this.selectedDate = null;
  //   this.componentId = this.selectedComponent?.componentId;
  //   this.getCMLNumber();
  // }

  getCMLNumber() {
    const reqBody = {
      VendorRegId: this.vendorId,
      ProgramId: this.programId,
      CategoryId: this.categoryId,
      // CompId: this.componentId,
    };

    this.loader.start();
    this.vendorService
      .getCMLNumber(reqBody)
      .pipe(first())
      .subscribe({
        next: (res) => {
          this.loader.close();
          // this.cml = res.$values;
          this.cml = res.$values.map((row) => ({
            ...row,
            // cmlNo_cmlValidity: JSON.stringify(row.cmlNo).concat(' ', row.cmlValidity),
            cmlNo_cmlValidity: row.cmlNo + ', ' + row.componentName + '.Valid Upto: ' + row.cmlValidity,
          }));
        },
        error: (err) => {
          this.loader.close();
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });
  }

  onSelectCML() {
    this.selectedDate = null;

    let selectedDate = this.selectedCML.cmlValidity.split('/');
    let mydate = new Date(selectedDate[2], selectedDate[1] - 1, selectedDate[0]); 
    this.selectedDate = new Date(mydate.toDateString());

    this.cmlId = this.selectedCML?.$id;
  }

  onSubmitCMLValidity() {
    let selectedDate = this.toISOLocal(new Date(this.selectedDate)).replace(
      /.\d+Z$/g,
      ''
    );

    let reqBody = {
      cmlNo: this.selectedCML.cmlNo,
      vendorCode: this.vendorId,
      progID: this.programId,
      catID: this.categoryId,
      updateValidityDate: selectedDate,
    };
    this.updateCMLValidity(reqBody);
  }

  updateCMLValidity(reqBody) {
    this.loader.start();
    this.vendorService
      .updateCMLValidity(reqBody)
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.loader.close();

          if(data = 'Record updated successfully'){
            this.messageService.add({
              severity: 'success',
              summary: 'Status',
              detail: data,
            });
          }
          else{
            this.messageService.add({
              severity: 'info',
              summary: 'Status',
              detail: data,
            });
          }
          
          this.loadData();
        },
        error: (err) => {
          this.loader.close();
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });
  }

  toISOLocal(d) {
    var z = (n) => ('0' + n).slice(-2);
    var off = d.getTimezoneOffset();
    off = Math.abs(off);

    return d.getFullYear() + '-' + z(d.getMonth() + 1) + '-' + z(d.getDate());
  }
}
